import { FC, useState } from "react";
import useI18n from "../../hooks/useTranslations";
import SvgArrowDropDown from "../icons/ArrowDropDown";
import SvgArrowDropUp from "../icons/ArrowDropUp";
import Icon from "./Icon";
import styles from "./InlineOrderEditor.module.css";

type InlineOrderEditorProps = {
  order?: number;
  onUpdate: (newOrder: number) => Promise<void>;
  disabled?: boolean;
  min?: number;
};

const InlineOrderEditor: FC<InlineOrderEditorProps> = ({ order = 0, onUpdate, disabled, min = 0 }) => {
  const [isPending, setIsPending] = useState(false);
  const i18n = useI18n();

  const handleChange = async (nextOrder: number) => {
    if (disabled || isPending || nextOrder < min || nextOrder === order) {
      return;
    }

    setIsPending(true);
    try {
      await onUpdate(nextOrder);
    } finally {
      setIsPending(false);
    }
  };

  return (
    <div className={styles.wrapper}>
      <button
        type="button"
        className={styles.button}
        onClick={(e) => {
          e.stopPropagation();
          handleChange(order + 1);
        }}
        // disabled={disabled || isPending}
        title={i18n.translation.common.increase(1)}
        aria-label={i18n.translation.common.increase(1)}
      >
        <Icon glyph={SvgArrowDropUp} className={styles.icon} />
      </button>
      <span className={styles.value}>{order}</span>
      <button
        type="button"
        className={styles.button}
        onClick={(e) => {
          e.stopPropagation();
          handleChange(order - 1);
        }}
        disabled={disabled || isPending || order <= min}
        title={i18n.translation.common.decrease(1)}
        aria-label={i18n.translation.common.decrease(1)}
      >
        <Icon glyph={SvgArrowDropDown} className={styles.icon} />
      </button>
    </div>
  );
};

export default InlineOrderEditor;
